const environnement = "production";
module.exports= {
    DEFAULT_BACKEND_URL: environnement=="local" ? "http://localhost:5001" : "https://agrigestion-backend.gouv.bj",
    DEFAULT_BACKEND_API_URL:environnement=="local" ? "http://localhost:5001/maep/v1/" : "https://agrigestion-backend.gouv.bj/maep/v1/",
    DEFAULT_FRONT_END_URL: environnement=="local" ? "https://eagri-maep.rightcomtech.com"  : "https://agrigestion.gouv.bj",
}